import { NavLink } from "react-router-dom";
import store from "../store";

// ICON
import kotIcon from "../img/KOT-icon.svg";

const TabNavigation = ({ activeTab, setActiveTab }) => {

  const dineInrunningOrders = store.runningKOTs?.filter(order => order.typeOfOrder !== "Takeaway") || []
  const parcelRunningOrders = store.runningKOTs?.filter(order => order.typeOfOrder == "Takeaway") || []

  return (
    <div className="flex items-center gap-2 border-b border-gray-300 p-2 px-6 max-w-[100vw] overflow-x-scroll hide-scrollbar">
      {/* Dine In Tab */}
      <NavLink
        to="/table-overview"
        onClick={() => setActiveTab("DineIn")}
        className={({ isActive }) =>
          `text-sm flex items-center justify-center gap-2 px-2 py-1 min-w-[125px]
              ${
                activeTab === "DineIn"
                  ? "bg-[#16A34A] border-[0.5px] border-black rounded text-white"
                  : "border-[0.5px] border-black rounded"
              }`
        }
      >
        Dine In
        <span
          style={{ border: "1px solid black" }}
          className="text-xs text-center bg-green-100 text-black rounded-full h-5 w-5"
        >
          {dineInrunningOrders?.length}
        </span>
      </NavLink>

      <button
        onClick={() => {
          setActiveTab("Parcel");
        }}
        className={`text-sm px-2 py-1 border-[0.5px] border-black rounded flex items-center justify-center gap-2 block min-w-[125px] ${
          activeTab === "Parcel"
            ? "bg-[#16A34A] border-[0.5px] border-black rounded text-white"
            : ""
        }`}
      >
        Parcel
        <span
          style={{ border: "1px solid black" }}
          className="text-xs text-center bg-green-100 text-black rounded-full h-5 w-5"
        >
          {parcelRunningOrders?.length}
        </span>
      </button>

      {/* Other Delivery Tab */}
      <button
        onClick={() => setActiveTab("Other")}
        className={`text-sm px-2 py-1 border-[0.5px] border-black rounded flex items-center justify-center gap-2 block min-w-[125px] ${
          activeTab === "Other"
            ? "bg-[#16A34A] border-[0.5px] border-black rounded text-white"
            : ""
        }`}
      >
        Other Delivery
      </button>

      <div className="flex-1"></div>
      <button
        onClick={() => store.setShowRunningKOT(true)}
        className="text-sm px-2 py-1 border-[0.5px] border-black rounded flex items-center justify-center gap-2 block min-w-[135px] max-w-[135px]"
      >
        <img src={kotIcon} alt="Running KOTs" />
        Running KOTs
      </button>
    </div>
  );
};

export default TabNavigation;
